import { Milk, Gem, Sparkles, RefreshCcw } from "lucide-react";
import { BottleStage } from "./BottleStage";
import { LuxButton, SectionHeading } from "../common/Primitives";
import { Reveal, RevealImage, Stagger, StaggerItem } from "../motion/Reveal";
import { IMG } from "../../config/site";
import { useUI } from "../../context/UIContext";

const FEATURES = [
  { icon: Milk, title: "750 ml", text: "Signature bottle format" },
  { icon: Gem, title: "Refined glass", text: "A considered finish for premium settings" },
  { icon: Sparkles, title: "Thoughtful presentation", text: "Designed to complement exceptional tables" },
  { icon: RefreshCcw, title: "Returnable format", text: "Intended for reuse through an appropriate collection and sanitation process" },
];

export const Bottle = () => {
  const { openPanel } = useUI();
  return (
    <section id="bottle" data-testid="bottle-section" className="relative overflow-hidden bg-[#EDE1CA]">
      <div className="mx-auto grid max-w-[1600px] lg:grid-cols-[1fr_1fr_0.95fr_0.42fr]">
        <div className="px-5 py-24 sm:px-8 lg:py-32 lg:pl-12 lg:pr-4">
          <SectionHeading eyebrow="The Bottle" lines={["A Statement", "on Every Table"]} />
          <Reveal delay={0.15}>
            <p className="body-lux mt-8 max-w-sm">
              Our signature 750 ml glass bottle is designed to bring understated elegance to the hospitality experience, combining
              distinctive presentation with a reusable packaging concept.
            </p>
            <LuxButton variant="line-dark" arrow className="mt-10" onClick={() => openPanel("bottle")} data-testid="bottle-details-btn">View bottle details</LuxButton>
          </Reveal>
        </div>

        <BottleStage onOpen={() => openPanel("bottle")} />

        <Stagger className="grid grid-cols-2 content-center gap-px self-center bg-[#B18A4A]/25 mx-5 my-16 sm:mx-8 lg:mx-6 lg:my-0">
          {FEATURES.map(({ icon: Icon, title, text }) => (
            <StaggerItem key={title} className="group flex min-h-[190px] flex-col items-center justify-center bg-[#F4EBDB] px-4 py-8 text-center transition-colors duration-500 hover:bg-[#F8F3E9]">
              <Icon className="h-7 w-7 text-[#B18A4A] transition-transform duration-700 group-hover:-translate-y-1" strokeWidth={1} aria-hidden="true" />
              <h3 className="mt-5 font-sans text-[11px] font-bold uppercase tracking-[0.22em] text-[#26231F]">{title}</h3>
              <p className="mt-2 text-[13px] leading-relaxed text-[#746D64]">{text}</p>
            </StaggerItem>
          ))}
        </Stagger>

        <RevealImage src={IMG.bottleDetail} alt="Close detail of the TOYAM bottle's tapered glass shoulder and gold mountain emblem" className="hidden h-full min-h-[640px] lg:block" />
      </div>
      <RevealImage src={IMG.bottleDetail} alt="Close detail of the TOYAM bottle's gold mountain emblem and wordmark" className="h-56 lg:hidden" imgClassName="object-[center_62%]" />
    </section>
  );
};
